import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { map } from 'rxjs/operators';
import { PortalService } from '../../../../../services/portal/portal.service';
import { BaseButtonSizeEnum } from '../../base-button/base-button-size.enum';
import { Routes } from '../../../../../routes/routes';
import { AccountTypeIdEnum } from '../../../../../models/transactions/enum/account-type-id.enum';
import { DateUtils } from '../../../../../utils/date-utils';

@Component({
  selector: 'app-vb-payment-change-submission-account-details-card',
  templateUrl: './vb-payment-change-submission-account-details-card.component.html',
  styleUrls: ['./vb-payment-change-submission-account-details-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VbPaymentChangeSubmissionAccountDetailsCardComponent {
  private portalService = inject(PortalService);

  @Input({ required: true }) estimatedAnnualTotal!: number;
  @Input() nextYearEstimatedAnnualTotal: number | null = null;
  @Input({ required: true }) annualMinimumAmount!: number;
  @Input() isAnnualMinimumEstimated = false;
  @Input() showGoToAccountButton: boolean = false;

  public nextYear = DateUtils.currentYearInCST() + 1;

  public estimatedAnnualTotalTooltip = $localize`This figure reflects all payments made to date in the current year, combined with upcoming recurring and lump sum payments planned for this VB account.`;

  public estimatedAnnualMinimumTooltip = $localize`The minimum total payment amount required for the year, based on estimates from the previous year for the variable benefit account balance(s) and the selected minimum age(s)`;

  public annualMinimumTooltip$ = this.portalService.isInternal$.pipe(
    map(isInternal => {
      if (isInternal) {
        return $localize`The minimum total payment amount required for the year, based on the Variable Benefit Account balance at the start of the year and the selected minimum age.`;
      } else {
        return $localize`Your required annual minimum payment, determined by your Variable Benefit Account's starting balance and minimum age selection.`;
      }
    })
  );

  public goToAccount(): void {
    const baseUrl = window.location.origin;
    const hashUrl = Routes.mpAccountDetails(AccountTypeIdEnum.VariableBenefitAccount);
    const fullUrl = `${baseUrl}/#${hashUrl}`;
    window.open(fullUrl, '_blank');
  }

  protected readonly BaseButtonSizeEnum = BaseButtonSizeEnum;
}
